import React, { useMemo } from "react";
import { createTheme, ThemeProvider, CssBaseline } from "@material-ui/core";

export const ThemeProviderOverride = ({
  theme,
  children,
}: {
  theme: any;
  children: React.ReactNode;
}): JSX.Element => {
  // Make any global edits to themes here
  const finalTheme = useMemo(() => createTheme(theme), [theme]);

  return (
    <ThemeProvider theme={finalTheme}>
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  );
};
